import api from './api'
import { LANGUAGE, NOTIFICATION_SETTING } from './endpoints'

export interface LanguageList {
  preferred_language: Language[]
}

export interface Language {
  name: string
  code: string
}
export type NotificationSettings = {
  location_preference: string[]
  category_preference: string[]
  email: boolean
  push: boolean
  enable_all_notifications: boolean
}

export interface LanguageDTO {
  preferred_language: string
}

export const getLanguageList = async () => {
  return (await api.get<{ data: any }>(LANGUAGE)).data
}

export const setPreferredLanguage = async (data: LanguageDTO) => {
  return await api.post<{ data: LanguageDTO }>(`${LANGUAGE}`, data)
}

export const getNotificationSettings = async () => {
  return (await api.get<{ data: NotificationSettings }>(NOTIFICATION_SETTING))
    .data
}

export const setNotificationSetting = async (
  data: Partial<NotificationSettings>
) => {
  return await api.patch<{ data: NotificationSettings }>(
    `${NOTIFICATION_SETTING}`,
    data
  )
}
